import { networkCall } from "../../../../../utils/network-call/network-call";

export const CompanyAdminProjectListLoader = async () => {
    const getProjectsResponse = await networkCall('/projects');
    return { getProjectsResponse };
};